/**
 * Generate a unique session ID for the chat session.
 */
export function generateSessionId() {
  return crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).slice(2);
}

/**
 * Format a timestamp into a readable time string.
 */
export function formatTime(ts) {
  if (!ts) return '';
  const d = new Date(ts);
  return d.toLocaleTimeString([], { hour: 'numeric', minute: '2-digit', hour12: true });
}

/**
 * Build a metadata badge string from the API response data.
 */
export function buildMetaBadge(data) {
  const intent = data.intent || '';
  const subType = data.sub_type || '';
  const so = data.extracted_so;
  const po = data.extracted_po;

  const parts = [`Intent: ${intent}`];
  if (subType && subType !== 'N/A') parts.push(`Subtype: ${subType}`);
  if (so) parts.push(`SO: ${so}`);
  if (po) parts.push(`PO: ${po}`);

  return parts.join(' | ');
}

/**
 * Format a live-agent estimated wait time (in minutes) into display text,
 * e.g. "2 minutes", "1 hour 5 minutes", "2 hours 1 minute".
 */
export function formatWaitTime(valueInMinutes) {
  const minuteText = 'minute';
  const minutesText = 'minutes';
  const hourText = 'hour';
  const hoursText = 'hours';

  if (valueInMinutes >= 60) {
    const hours = Math.floor(valueInMinutes / 60);
    const minutes = valueInMinutes % 60;
    const hoursLabel = hours > 1 ? hoursText : hourText;
    const minutesLabel = minutes > 1 ? minutesText : minuteText;
    return minutes > 0 ? `${hours} ${hoursLabel} ${minutes} ${minutesLabel}` : `${hours} ${hoursLabel}`;
  }

  return `${valueInMinutes} ${valueInMinutes > 1 ? minutesText : minuteText}`;
}
